// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/italianno/subset-Italianno-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/italianno/subset-Italianno-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/playfair-display/subset-PlayfairDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/playfair-display/subset-PlayfairDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/cormorant/subset-Cormorant-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/cormorant/subset-Cormorant-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/cormorant/subset-Cormorant-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/cormorant/subset-Cormorant-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/fonts/cormorant/subset-Cormorant-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("assets/fonts/cormorant/subset-Cormorant-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */

/* Logo font - Italianno */
@font-face {
  /* Italianno Regular */
  font-family: 'Italianno';

  src:  local('Italianno Regular'), local('Italianno-Regular'),
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');

  font-weight: normal;
  font-style: normal;

  font-display: block;
}

/* Heading font - Playfair display */
@font-face {
  /* Playfair Display Bold */
  font-family: 'Playfair Display';

  src:  local('Playfair Display Bold'), local('PlayfairDisplay-Bold'),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');

  font-weight: bold;
  font-style: normal;

  font-display: swap;
}

/* Paragraph font - Cormorant */

@font-face {
  /* Cormorant Medium */
  font-family: 'Cormorant';

  src:  local('Cormorant Medium'), local('Cormorant-Medium'),
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');

  font-weight: 500;
  font-style: normal;

  font-display: swap;
}

@font-face {
  /* Cormorant Medium Italic */
  font-family: 'Cormorant';

  src:  local('Cormorant Medium Italic'), local('Cormorant-MediumItalic'),
        url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');

  font-weight: 500;
  font-style: italic;

  font-display: swap;
}

@font-face {
  /* Cormorant Bold */
  font-family: 'Cormorant';

  src:  local('Cormorant Bold'), local('Cormorant-Bold'),
        url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');

  font-weight: bold;
  font-style: normal;

  font-display: swap;
}

/* CSS Variables */
:root {
  /* Fonts */

  /* TODO: Use separate fallback system font stacks for different fonts. Recommended source: Modern Font Stacks */

  --system-font-stack-serif: "Iowan Old Style", "Apple Garamond", Baskerville, "Times New Roman", "Droid Serif", Times, "Source Serif Pro", serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";

  --logo-font: "Italianno", var(--system-font-stack-serif);
  --title-font: "Playfair Display", var(--system-font-stack-serif);
  --text-font: "Cormorant", var(--system-font-stack-serif);

  /* Colors */

  --background-color: linear-gradient(135deg, #1A1A1A 0%, #2C1810 25%, #3D2418 50%, #2C1810 75%, #1A1A1A 100%);;
  --foreground-color: #D4AF37;
  --text-color: #E0D4B8;

  /* Used in bottom borders of tab buttons on hover. */
  --foreground-color-transparent: #D4AD3780;
  --text-color-transparent: #e0d4b84d;
}

/* (0) General Styles*/

*, *::before, *::after {
  box-sizing: border-box;

  margin: 0;
  padding: 0;
}

*:focus, *:focus-visible {
  outline: none;
}

::selection {
  background-color: var(--foreground-color-transparent);
}

.colored::selection {
  background-color: var(--text-color-transparent);
}

a:has(> svg) {
  display: inline-flex;
  justify-content: center;
  align-items: center;

  width: fit-content;
}

h1:active, a:active, .tab:active {
  text-shadow: none;
}

a:hover, a:focus-visible {
  text-shadow: 0 0 10px var(--foreground-color);
}

svg {
  display: inline;

  height: 100%;
  width: 1.5ch;

  padding-left: 0.1em;
}

#skip-navigation {
  display: block;

  position: absolute;
  top: 0;

  transform: translateY(-100%);

  text-align: center;

  width: 100%;

  padding: 1rem 0;
  border: 4px solid var(--foreground-color);
  margin-top: 0.25px;

  background-color: rgba(200, 200, 210, 0.06);

  text-transform: capitalize;
}

#skip-navigation:focus {
  position: static;

  transform: translateY(0%);
}

button:hover, button:focus-visible, #logo:hover, #logo:focus {
  text-shadow: 0 0 16px var(--foreground-color);
}

button {
  appearance: none;
  border: none;

  cursor: pointer;
}

b {
  /* The bring attention to element (\`b\`) is not required to be rendered in bold as per the specification. */
  font-weight: bold;
}

i {
  /* The idiomatic text element (\`i\`) is not required to be rendered in italics as per the specification. */
  font-style: italic;
}

.colored, a.colored:visited {
  color: var(--foreground-color);
}

h2, .section-title {
  font-family: var(--title-font);
  font-size: 3rem;

  margin-bottom: 24px;
}

.section-content > * {
  margin-bottom: 20px;
}

.section-content > :last-child {
  margin-bottom: 48px;
}

.section-content ul, .section-content ol, .section-content dl {
  padding-top: 16px;

  padding-left: 64px;
}

body {
  display: grid;
  grid-template-rows: auto 1fr auto;

  place-items: center;

  height: 100vh;

  font-family: var(--text-font);
  font-size: 1.9rem;

  background-image: var(--background-color);

  /* Forces the background to be fixed to the viewport without getting cut off on scrolling (as its size is smaller than the size of the viewport) */
  background-attachment: fixed;

  color: var(--text-color);
}

/* (1) Header styles */

header {
  padding-bottom: 64px;
}

#logo {
  font-family: var(--logo-font);
  font-size: 5rem;

  margin-top: 32px;
  margin-bottom: 16px;

  cursor: pointer;
}

header > nav {
  display: flex;
  justify-content: space-evenly;
}

.tab {
  font-family: var(--logo-font);
  font-size: 2rem;

  padding: 0 5px 2px 5px;

  background-color: transparent;
}

.tab.active-tab, .tab:hover, .tab:focus-visible {
  --border-width: 4px;

  border-bottom: var(--border-width) solid var(--foreground-color);

  /* To prevent button text from shifting upwards on hover/keyboard focus. */
  padding-top: var(--border-width);
}

.tab:hover, .tab:focus-visible {
  border-bottom-color: var(--foreground-color-transparent);
}

/* (2) Content styles - Home tab */

#content {
  place-self: stretch;
}

#content > * {
  padding-left: 64px;
  padding-right: 64px;
}

#main-image-container {
  text-align: center;

  margin-bottom: 32px;
  padding: 0;
}

#headline {
  font-family: var(--title-font);
  font-size: 4rem;

  margin-bottom: 32px;
}

#main-image-container img, .item-image {
  border: 2px solid var(--foreground-color);
}

.statement {
  margin-bottom: 20px;
}

.statement > :not(:last-child) {
  margin-bottom: 8px;
}

#punchline {
  font-weight: bold;

  font-size: 1.1em;
}

/* (3) Content Styles - Menu tab */

#menu {
  --padding-left-right: 64px;

  list-style-type: none;

  padding-left: var(--padding-left-right);
  padding-right: var(--padding-left-right);
}

.menu-item {
  --padding-top-bottom: 64px;

  display: flex;
  flex-direction: column;
}

.menu-item:not(:first-child) {
  padding-top: var(--padding-top-bottom);
}

.menu-item-parent {
  display: flex;

  gap: 64px;

  padding-bottom: var(--padding-top-bottom);
}

.menu-item:nth-child(2n + 1) > .menu-item-parent {
  flex-direction: row-reverse;
}

.menu-item:not(:last-child)::after, .reservation-section dt::after {
  content: '';

  align-self: center;

  width: 20%;
  height: 4px;

  background-color: var(--foreground-color);
}

.item-image {
  align-self: center;
  flex: 1.2;

  display: grid;
  place-content: stretch;

  font-size: 1.5rem;
  font-weight: bold;

  text-transform: uppercase;

  /* Force all image containers to have the same height, even when they contain no images or images of different dimensions. */
  height: 350px;

  /* Prevent the cursor from changing appearance on hovering over the "Photo unavailable" text. */
  cursor: default;
}

.item-image img {
  display: block;

  object-fit: cover;
  width: 100%;
  height: 100%;
}
.item-text {
  flex: 3;

  display: flex;
  flex-direction: column;

  padding: 16px 0;
}

.item-description > * {
  margin-bottom: 16px;
}

.chef-name {
  margin-bottom: 48px;
}

.chef-name, .item-price {
  font-size: 2rem;
}

.item-price {
  margin-top: auto;
}

/* (4) Content styles - About tab */

.reservation-section {
  text-align: center;
}

.reservation-section > .section {
  border: 2px solid var(--foreground-color);
  padding: 32px;

  text-align: center;
}

.reservation-section p:first-child {
  margin-bottom: 64px;
}

.reservation-section dl {
  padding: 0;
}

.reservation-section dt {
  display: flex;
  flex-direction: column;

  font-weight: bold;

  padding-bottom: 20px;
}

.reservation-section dt::after {
  margin-top: 8px;

  width: 3.5ch;
}

.reservation-section dd:not(:last-child) {
  margin-bottom: 48px;
}

/* (3) Footer styles */

footer {
  width: 100%;

  margin-top: 48px;
  padding: 16px 0;
  border-top: 1px solid var(--foreground-color);

  text-align: center;

  font-size: 1.5rem;
}

/* Extra: Dish suggestion paragraph styles */
.suggest-dish-notification {
  padding: 8px 0;
  border: 2px double var(--foreground-color);
  margin-bottom: 64px;

  place-self: center;

  font-size: 1.5rem;

  width: fit-content;

  background-color: rgba(200, 200, 210, 0.06);
}

/* (*) Transitions and Animations */

@media (prefers-reduced-motion: reduce) {
  * {
    transition: none;
  }
}

@media (prefers-reduced-motion: no-preference) {
  #skip-navigation {
    transition-property: transform;
  }

  h1, a, .tab {
    transition: text-shadow 0.55s ease-out;
  }

  a, .tab {
    transition-duration: 0.25s;
  }

  h1:hover, h1:focus, a:hover, a:focus, .tab:hover, .tab:focus {
    transition-timing-function: ease-in;
  }
  
  #headline-and-text, .item-text, .reservation-section .section {
    transition: text-shadow 0.25s ease-out;
  }

  #headline-and-text {
    transition-property: text-shadow, filter;
  }

  #headline-and-text:hover, .item-text:hover, .reservation-section:hover .section {
    transition-timing-function: ease-in;
  }

  #main-image-container img {
    transition: filter 0.5s ease-out;
  }

  #main-image-container img, .item-image {
    transition-property: filter, transform;
    transition-duration: 0.25s;
    transition-timing-function: linear, ease-out;
  }

  .menu-item-parent:hover .item-image, .menu-item-parent:focus .item-image {
    transition-timing-function: ease-in;
  }
}

#headline-and-text:hover {
  text-shadow: 0 0 2.5rem var(--text-color);
  filter: brightness(0.94);
}

#headline-and-text:hover .colored {
  text-shadow: 0 0 4rem var(--foreground-color);
}

#main-image-container img:hover, #main-image-container a:focus img {
  filter: drop-shadow(0 0 24px var(--foreground-color));
}

.menu-item-parent:hover .item-image, .menu-item-parent:focus .item-image {
  filter: drop-shadow(0 0 14px var(--foreground-color));

  transform: scale(1.03);
}

.menu-item-parent:hover .item-text, .menu-item-parent:focus .item-text, .reservation-section:hover .section {
  text-shadow: 0 0 2.3rem var(--text-color);
}

.menu-item-parent:hover .colored, .menu-item-parent:focus .colored, .reservation-section:hover .colored {
  text-shadow: 0 0 2.2rem var(--foreground-color);
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,UAAU;;AAEV,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,wBAAwB;;EAExB;;8DAEgF;;EAEhF,mBAAmB;EACnB,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,0BAA0B;EAC1B,+BAA+B;;EAE/B;;8DAE0F;;EAE1F,iBAAiB;EACjB,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA,+BAA+B;;AAE/B;EACE,qBAAqB;EACrB,wBAAwB;;EAExB;;8DAE+E;;EAE/E,gBAAgB;EAChB,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;;EAExB;;8DAEqF;;EAErF,gBAAgB;EAChB,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;;EAExB;;8DAE6E;;EAE7E,iBAAiB;EACjB,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,UAAU;;EAEV,+GAA+G;;EAE/G,yMAAyM;;EAEzM,wDAAwD;EACxD,gEAAgE;EAChE,wDAAwD;;EAExD,WAAW;;EAEX,4GAA4G;EAC5G,2BAA2B;EAC3B,qBAAqB;;EAErB,oDAAoD;EACpD,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA,sBAAsB;;AAEtB;EACE,sBAAsB;;EAEtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;;EAEnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;;EAEf,YAAY;EACZ,YAAY;;EAEZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;;EAEd,kBAAkB;EAClB,MAAM;;EAEN,4BAA4B;;EAE5B,kBAAkB;;EAElB,WAAW;;EAEX,eAAe;EACf,yCAAyC;EACzC,kBAAkB;;EAElB,2CAA2C;;EAE3C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;;EAEhB,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,YAAY;;EAEZ,eAAe;AACjB;;AAEA;EACE,0GAA0G;EAC1G,iBAAiB;AACnB;;AAEA;EACE,yGAAyG;EACzG,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;;EAEf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;;EAEjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iCAAiC;;EAEjC,mBAAmB;;EAEnB,aAAa;;EAEb,6BAA6B;EAC7B,iBAAiB;;EAEjB,yCAAyC;;EAEzC,kJAAkJ;EAClJ,4BAA4B;;EAE5B,wBAAwB;AAC1B;;AAEA,sBAAsB;;AAEtB;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;;EAEf,gBAAgB;EAChB,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;;EAEf,sBAAsB;;EAEtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;;EAEnB,gEAAgE;;EAEhE,0EAA0E;EAC1E,gCAAgC;AAClC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,kCAAkC;;AAElC;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;EAElB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,eAAe;;EAEf,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;;EAEjB,gBAAgB;AAClB;;AAEA,kCAAkC;;AAElC;EACE,0BAA0B;;EAE1B,qBAAqB;;EAErB,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;;EAE1B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;;EAEb,SAAS;;EAET,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;;EAEX,kBAAkB;;EAElB,UAAU;EACV,WAAW;;EAEX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;;EAET,aAAa;EACb,sBAAsB;;EAEtB,iBAAiB;EACjB,iBAAiB;;EAEjB,yBAAyB;;EAEzB,4HAA4H;EAC5H,aAAa;;EAEb,+FAA+F;EAC/F,eAAe;AACjB;;AAEA;EACE,cAAc;;EAEd,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,OAAO;;EAEP,aAAa;EACb,sBAAsB;;EAEtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;;AAEnC;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,aAAa;;EAEb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,iBAAiB;;EAEjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;;EAEf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;;AAEtB;EACE,WAAW;;EAEX,gBAAgB;EAChB,eAAe;EACf,6CAA6C;;EAE7C,kBAAkB;;EAElB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;;EAEnB,kBAAkB;;EAElB,iBAAiB;;EAEjB,kBAAkB;;EAElB,2CAA2C;AAC7C;;AAEA,mCAAmC;;AAEnC;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sCAAsC;IACtC,0BAA0B;IAC1B,4CAA4C;EAC9C;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;;EAErD,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":["/* Fonts */\n\n/* Logo font - Italianno */\n@font-face {\n  /* Italianno Regular */\n  font-family: 'Italianno';\n\n  src:  local('Italianno Regular'), local('Italianno-Regular'),\n        url('assets/fonts/italianno/subset-Italianno-Regular.woff2') format('woff2'),\n        url('assets/fonts/italianno/subset-Italianno-Regular.woff') format('woff');\n\n  font-weight: normal;\n  font-style: normal;\n\n  font-display: block;\n}\n\n/* Heading font - Playfair display */\n@font-face {\n  /* Playfair Display Bold */\n  font-family: 'Playfair Display';\n\n  src:  local('Playfair Display Bold'), local('PlayfairDisplay-Bold'),\n        url('assets/fonts/playfair-display/subset-PlayfairDisplay-Bold.woff2') format('woff2'),\n        url('assets/fonts/playfair-display/subset-PlayfairDisplay-Bold.woff') format('woff');\n\n  font-weight: bold;\n  font-style: normal;\n\n  font-display: swap;\n}\n\n/* Paragraph font - Cormorant */\n\n@font-face {\n  /* Cormorant Medium */\n  font-family: 'Cormorant';\n\n  src:  local('Cormorant Medium'), local('Cormorant-Medium'),\n        url('assets/fonts/cormorant/subset-Cormorant-Medium.woff2') format('woff2'),\n        url('assets/fonts/cormorant/subset-Cormorant-Medium.woff') format('woff');\n\n  font-weight: 500;\n  font-style: normal;\n\n  font-display: swap;\n}\n\n@font-face {\n  /* Cormorant Medium Italic */\n  font-family: 'Cormorant';\n\n  src:  local('Cormorant Medium Italic'), local('Cormorant-MediumItalic'),\n        url('assets/fonts/cormorant/subset-Cormorant-MediumItalic.woff2') format('woff2'),\n        url('assets/fonts/cormorant/subset-Cormorant-MediumItalic.woff') format('woff');\n\n  font-weight: 500;\n  font-style: italic;\n\n  font-display: swap;\n}\n\n@font-face {\n  /* Cormorant Bold */\n  font-family: 'Cormorant';\n\n  src:  local('Cormorant Bold'), local('Cormorant-Bold'),\n        url('assets/fonts/cormorant/subset-Cormorant-Bold.woff2') format('woff2'),\n        url('assets/fonts/cormorant/subset-Cormorant-Bold.woff') format('woff');\n\n  font-weight: bold;\n  font-style: normal;\n\n  font-display: swap;\n}\n\n/* CSS Variables */\n:root {\n  /* Fonts */\n\n  /* TODO: Use separate fallback system font stacks for different fonts. Recommended source: Modern Font Stacks */\n\n  --system-font-stack-serif: \"Iowan Old Style\", \"Apple Garamond\", Baskerville, \"Times New Roman\", \"Droid Serif\", Times, \"Source Serif Pro\", serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n\n  --logo-font: \"Italianno\", var(--system-font-stack-serif);\n  --title-font: \"Playfair Display\", var(--system-font-stack-serif);\n  --text-font: \"Cormorant\", var(--system-font-stack-serif);\n\n  /* Colors */\n\n  --background-color: linear-gradient(135deg, #1A1A1A 0%, #2C1810 25%, #3D2418 50%, #2C1810 75%, #1A1A1A 100%);;\n  --foreground-color: #D4AF37;\n  --text-color: #E0D4B8;\n\n  /* Used in bottom borders of tab buttons on hover. */\n  --foreground-color-transparent: #D4AD3780;\n  --text-color-transparent: #e0d4b84d;\n}\n\n/* (0) General Styles*/\n\n*, *::before, *::after {\n  box-sizing: border-box;\n\n  margin: 0;\n  padding: 0;\n}\n\n*:focus, *:focus-visible {\n  outline: none;\n}\n\n::selection {\n  background-color: var(--foreground-color-transparent);\n}\n\n.colored::selection {\n  background-color: var(--text-color-transparent);\n}\n\na:has(> svg) {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  width: fit-content;\n}\n\nh1:active, a:active, .tab:active {\n  text-shadow: none;\n}\n\na:hover, a:focus-visible {\n  text-shadow: 0 0 10px var(--foreground-color);\n}\n\nsvg {\n  display: inline;\n\n  height: 100%;\n  width: 1.5ch;\n\n  padding-left: 0.1em;\n}\n\n#skip-navigation {\n  display: block;\n\n  position: absolute;\n  top: 0;\n\n  transform: translateY(-100%);\n\n  text-align: center;\n\n  width: 100%;\n\n  padding: 1rem 0;\n  border: 4px solid var(--foreground-color);\n  margin-top: 0.25px;\n\n  background-color: rgba(200, 200, 210, 0.06);\n\n  text-transform: capitalize;\n}\n\n#skip-navigation:focus {\n  position: static;\n\n  transform: translateY(0%);\n}\n\nbutton:hover, button:focus-visible, #logo:hover, #logo:focus {\n  text-shadow: 0 0 16px var(--foreground-color);\n}\n\nbutton {\n  appearance: none;\n  border: none;\n\n  cursor: pointer;\n}\n\nb {\n  /* The bring attention to element (`b`) is not required to be rendered in bold as per the specification. */\n  font-weight: bold;\n}\n\ni {\n  /* The idiomatic text element (`i`) is not required to be rendered in italics as per the specification. */\n  font-style: italic;\n}\n\n.colored, a.colored:visited {\n  color: var(--foreground-color);\n}\n\nh2, .section-title {\n  font-family: var(--title-font);\n  font-size: 3rem;\n\n  margin-bottom: 24px;\n}\n\n.section-content > * {\n  margin-bottom: 20px;\n}\n\n.section-content > :last-child {\n  margin-bottom: 48px;\n}\n\n.section-content ul, .section-content ol, .section-content dl {\n  padding-top: 16px;\n\n  padding-left: 64px;\n}\n\nbody {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n\n  place-items: center;\n\n  height: 100vh;\n\n  font-family: var(--text-font);\n  font-size: 1.9rem;\n\n  background-image: var(--background-color);\n\n  /* Forces the background to be fixed to the viewport without getting cut off on scrolling (as its size is smaller than the size of the viewport) */\n  background-attachment: fixed;\n\n  color: var(--text-color);\n}\n\n/* (1) Header styles */\n\nheader {\n  padding-bottom: 64px;\n}\n\n#logo {\n  font-family: var(--logo-font);\n  font-size: 5rem;\n\n  margin-top: 32px;\n  margin-bottom: 16px;\n\n  cursor: pointer;\n}\n\nheader > nav {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.tab {\n  font-family: var(--logo-font);\n  font-size: 2rem;\n\n  padding: 0 5px 2px 5px;\n\n  background-color: transparent;\n}\n\n.tab.active-tab, .tab:hover, .tab:focus-visible {\n  --border-width: 4px;\n\n  border-bottom: var(--border-width) solid var(--foreground-color);\n\n  /* To prevent button text from shifting upwards on hover/keyboard focus. */\n  padding-top: var(--border-width);\n}\n\n.tab:hover, .tab:focus-visible {\n  border-bottom-color: var(--foreground-color-transparent);\n}\n\n/* (2) Content styles - Home tab */\n\n#content {\n  place-self: stretch;\n}\n\n#content > * {\n  padding-left: 64px;\n  padding-right: 64px;\n}\n\n#main-image-container {\n  text-align: center;\n\n  margin-bottom: 32px;\n  padding: 0;\n}\n\n#headline {\n  font-family: var(--title-font);\n  font-size: 4rem;\n\n  margin-bottom: 32px;\n}\n\n#main-image-container img, .item-image {\n  border: 2px solid var(--foreground-color);\n}\n\n.statement {\n  margin-bottom: 20px;\n}\n\n.statement > :not(:last-child) {\n  margin-bottom: 8px;\n}\n\n#punchline {\n  font-weight: bold;\n\n  font-size: 1.1em;\n}\n\n/* (3) Content Styles - Menu tab */\n\n#menu {\n  --padding-left-right: 64px;\n\n  list-style-type: none;\n\n  padding-left: var(--padding-left-right);\n  padding-right: var(--padding-left-right);\n}\n\n.menu-item {\n  --padding-top-bottom: 64px;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.menu-item:not(:first-child) {\n  padding-top: var(--padding-top-bottom);\n}\n\n.menu-item-parent {\n  display: flex;\n\n  gap: 64px;\n\n  padding-bottom: var(--padding-top-bottom);\n}\n\n.menu-item:nth-child(2n + 1) > .menu-item-parent {\n  flex-direction: row-reverse;\n}\n\n.menu-item:not(:last-child)::after, .reservation-section dt::after {\n  content: '';\n\n  align-self: center;\n\n  width: 20%;\n  height: 4px;\n\n  background-color: var(--foreground-color);\n}\n\n.item-image {\n  align-self: center;\n  flex: 1.2;\n\n  display: grid;\n  place-content: stretch;\n\n  font-size: 1.5rem;\n  font-weight: bold;\n\n  text-transform: uppercase;\n\n  /* Force all image containers to have the same height, even when they contain no images or images of different dimensions. */\n  height: 350px;\n\n  /* Prevent the cursor from changing appearance on hovering over the \"Photo unavailable\" text. */\n  cursor: default;\n}\n\n.item-image img {\n  display: block;\n\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n.item-text {\n  flex: 3;\n\n  display: flex;\n  flex-direction: column;\n\n  padding: 16px 0;\n}\n\n.item-description > * {\n  margin-bottom: 16px;\n}\n\n.chef-name {\n  margin-bottom: 48px;\n}\n\n.chef-name, .item-price {\n  font-size: 2rem;\n}\n\n.item-price {\n  margin-top: auto;\n}\n\n/* (4) Content styles - About tab */\n\n.reservation-section {\n  text-align: center;\n}\n\n.reservation-section > .section {\n  border: 2px solid var(--foreground-color);\n  padding: 32px;\n\n  text-align: center;\n}\n\n.reservation-section p:first-child {\n  margin-bottom: 64px;\n}\n\n.reservation-section dl {\n  padding: 0;\n}\n\n.reservation-section dt {\n  display: flex;\n  flex-direction: column;\n\n  font-weight: bold;\n\n  padding-bottom: 20px;\n}\n\n.reservation-section dt::after {\n  margin-top: 8px;\n\n  width: 3.5ch;\n}\n\n.reservation-section dd:not(:last-child) {\n  margin-bottom: 48px;\n}\n\n/* (3) Footer styles */\n\nfooter {\n  width: 100%;\n\n  margin-top: 48px;\n  padding: 16px 0;\n  border-top: 1px solid var(--foreground-color);\n\n  text-align: center;\n\n  font-size: 1.5rem;\n}\n\n/* Extra: Dish suggestion paragraph styles */\n.suggest-dish-notification {\n  padding: 8px 0;\n  border: 2px double var(--foreground-color);\n  margin-bottom: 64px;\n\n  place-self: center;\n\n  font-size: 1.5rem;\n\n  width: fit-content;\n\n  background-color: rgba(200, 200, 210, 0.06);\n}\n\n/* (*) Transitions and Animations */\n\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition: none;\n  }\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  #skip-navigation {\n    transition-property: transform;\n  }\n\n  h1, a, .tab {\n    transition: text-shadow 0.55s ease-out;\n  }\n\n  a, .tab {\n    transition-duration: 0.25s;\n  }\n\n  h1:hover, h1:focus, a:hover, a:focus, .tab:hover, .tab:focus {\n    transition-timing-function: ease-in;\n  }\n  \n  #headline-and-text, .item-text, .reservation-section .section {\n    transition: text-shadow 0.25s ease-out;\n  }\n\n  #headline-and-text {\n    transition-property: text-shadow, filter;\n  }\n\n  #headline-and-text:hover, .item-text:hover, .reservation-section:hover .section {\n    transition-timing-function: ease-in;\n  }\n\n  #main-image-container img {\n    transition: filter 0.5s ease-out;\n  }\n\n  #main-image-container img, .item-image {\n    transition-property: filter, transform;\n    transition-duration: 0.25s;\n    transition-timing-function: linear, ease-out;\n  }\n\n  .menu-item-parent:hover .item-image, .menu-item-parent:focus .item-image {\n    transition-timing-function: ease-in;\n  }\n}\n\n#headline-and-text:hover {\n  text-shadow: 0 0 2.5rem var(--text-color);\n  filter: brightness(0.94);\n}\n\n#headline-and-text:hover .colored {\n  text-shadow: 0 0 4rem var(--foreground-color);\n}\n\n#main-image-container img:hover, #main-image-container a:focus img {\n  filter: drop-shadow(0 0 24px var(--foreground-color));\n}\n\n.menu-item-parent:hover .item-image, .menu-item-parent:focus .item-image {\n  filter: drop-shadow(0 0 14px var(--foreground-color));\n\n  transform: scale(1.03);\n}\n\n.menu-item-parent:hover .item-text, .menu-item-parent:focus .item-text, .reservation-section:hover .section {\n  text-shadow: 0 0 2.3rem var(--text-color);\n}\n\n.menu-item-parent:hover .colored, .menu-item-parent:focus .colored, .reservation-section:hover .colored {\n  text-shadow: 0 0 2.2rem var(--foreground-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
